import { get } from '../../base';

import { ProfilesResponse } from './types-get-user-profiles';

export function getUserProfiles(authToken?: string) {
  const headers = authToken ? { authorization: `Bearer ${authToken}` } : undefined;
  return get('v5/user/profiles', { headers }).json<ProfilesResponse>();
}
